import { AAMode, proxyBase, setAAMode, setProxy } from '../../modules/config';
import { Badge, ClickAwayListener, Divider, Drawer, Hidden, ListItem, ListItemIcon, ListItemText, ListSubheader, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import { IconDefinition, faCarCrash, faCheck, faChevronLeft, faChevronRight, faCreditCard, faCrown, faEnvelopeOpenText, faFingerprint, faHandHoldingUsd, faPhone, faProjectDiagram, faQuestion, faSearchDollar, faSignInAlt, faSignature, faSms, faTimes, faUniversity } from '@fortawesome/free-solid-svg-icons';
import React, { Component, Fragment, MouseEvent } from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Theme, WithStyles, WithTheme, createStyles, withStyles } from '@material-ui/core/styles';
import { handleNewBroadcast, setViewerVisibility } from '../../modules/tracelog';
import { initApi, setForceWorkflow, setRequestArgs } from '../../modules/api';

import AppBar from '@material-ui/core/AppBar';
import BindContainer from '../bind/BindContainer';
import ChallengeDialog from '../challenge/ChallengeDialog';
import Copyright from '../../components/Copyright';
import EnrollContainer from '../enroll';
import ErrorPage from '../ErrorPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Login from '../login';
import Mousetrap from 'mousetrap';
import PIBContainer from '../pib/PIBContainer';
import PibMenu from '../common/PibMenu';
import SoapViewer from '../soap-viewer';
import Toolbar from '@material-ui/core/Toolbar';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { logout } from '../../modules/auth';
import { push } from 'connected-react-router';

const Websocket: any = require('react-websocket')

const drawerWidth = 240;

const styles = (theme: Theme) => createStyles({
  root: {
    minHeight: '100vh',
    maxHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignContent: 'stretch',
    alignItems: 'stretch',
  },
  appBar: {
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 2px 1px rgba(0,0,0,0.1)',
    flex: "0 0 auto",
  },
  toolbar: {
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'center',
    paddingLeft: 0,
    paddingRight: 0
  },
  grow: {
    flexGrow: 1,
  },
  main: {
    flex: "1 1 auto",
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
    overflowX: 'auto',
  },
  logo: {
    maxHeight: theme.spacing(5),
  },
  appBarMenu: {
    "& li": {
      color: 'red',
      display: 'inline-block',
      "& a:link, & a:visited": {
        color: '#333',
        textDecoration: 'none',
        padding: theme.spacing(2),
        position: 'relative',
        top: '-1px',
      },
      "& a:hover, & a:active": {
        color: '#999',
      }
    },
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    height: '80px',
    justifyContent: 'flex-end',
  },
  listItemIcon: {
    margin: `0 ${theme.spacing(1)}px`,
    width: `${theme.spacing(1)}px`,
    minWidth: `${theme.spacing(5)}px`,
    "& > *": {
      margin: '0 auto',
    }
  },
  divider: {
    margin: `${theme.spacing()}px 0`,
  },
  forceWorkflowSubheader: {
    backgroundColor: "white"
  },
  copyright: {
    opacity: 0.3,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  }
});

type State = {
  menuOpen: boolean
  menuForceWorkflow: HTMLElement | null
}

class MainApp extends Component<Props, State> {
  menuItems = ['Bank', 'Cards', 'Insure', 'Borrow', 'Invest'];

  state: State = {
    menuOpen: false,
    menuForceWorkflow: null
  }

  constructor(props: Props) {
    super(props)

    const { match, setProxy, config, setAAMode } = this.props

    if (config.aa.mode !== this.props.mode)
      setAAMode(this.props.mode)

    if (this.props.mode === "proxy" && match)
      setProxy(match.params.proxyId)
  }

  handleDrawerOpen() {
    this.setState({ menuOpen: true })
  }
  handleDrawerClose() {
    this.setState({ menuOpen: false })
  }
  handleForceWorkflow = (value: string | null) => () => {
    this.props.setForceWorkflow(value)
    this.setState({
      menuForceWorkflow: null
    })
  }

  handleForceWorkflowMenu = (state: boolean) => (e: MouseEvent<HTMLElement>) => {
    this.setState({
      menuForceWorkflow: state ? e.currentTarget : null
    })
  }

  componentDidMount() {
    const { setRequestArgs, initApi } = this.props

    if (encode_deviceprint)
      setRequestArgs({ deviceRequest: { devicePrint: encode_deviceprint() } })

    initApi()
    Mousetrap.bind('alt+`', this.toggleSoapViewerOpen)

    setInterval(() => {
      try {
        if (this.refWebsocket.current)
          this.refWebsocket.current.state.ws.send("{type:\"heartbeat\",time:" + Date.now() + "}")
      }
      catch (e) {
        console.log(e)
      }
    }, 10000)
  }

  handleSoapViewerOpen = (open: boolean) => {
    this.props.setViewerVisibility(true)
  }

  toggleSoapViewerOpen = () => {
    const { setViewerVisibility, tracelog } = this.props
    setViewerVisibility(!tracelog.viewerOpen)
  }

  handleMessage = (data: any) => {
    const { handleNewBroadcast } = this.props
    handleNewBroadcast(data)
  }

  handleClickHome = (e: MouseEvent) => {
    const { push, proxyBase } = this.props
    push(window.location.pathname === proxyBase() ? '/' : proxyBase())
    e.preventDefault()
  }
  refWebsocket = React.createRef<typeof Websocket>()

  render() {
    const { api, challenge, classes, auth, match, config, tracelog, theme } = this.props
    const { menuOpen, menuForceWorkflow } = this.state

    let menuItems = [
      { text: 'Bank', icon: faUniversity },
      { text: 'Cards', icon: faCreditCard },
      { text: 'Insure', icon: faCarCrash },
      { text: 'Borrow', icon: faHandHoldingUsd },
      { text: 'Invest', icon: faCrown }
    ]

    let forceWorkflows: { text: string, icon: IconDefinition, value: string, divider?: boolean }[] = [
      { text: 'Allow', icon: faCheck, value: 'Allow' },
      { text: 'Review', icon: faSearchDollar, value: 'Review' },
      { text: 'Deny', icon: faTimes, value: 'Deny', divider: true },
      { text: 'Question', icon: faQuestion, value: 'Question' },
      { text: 'OOB Phone', icon: faPhone, value: 'OOB-Phone' },
      { text: 'OOB SMS', icon: faSms, value: 'OOB-SMS' },
      { text: 'Biometrics', icon: faFingerprint, value: 'Biometric' },
      { text: 'Push OTP', icon: faSignInAlt, value: 'OtpApp' },
      { text: 'Transaction Signing', icon: faSignature, value: 'TRXSIGN' }
    ]

    return (
      <Fragment>
        {(config.aa.mode === "proxy" || config.aa.mode === "direct") &&
          <Websocket url={window.location.protocol.replace('http', 'ws') + "//" + window.location.host + "/ws/hub/" + config.aa.mode + "/" + (config.aa.mode === "proxy" ? config.aa.proxyId : encodeURIComponent(config.aa.endpoint))} onMessage={this.handleMessage} ref={this.refWebsocket} />
        }
        {challenge.open &&
          <ChallengeDialog></ChallengeDialog>
        }
        <div className={classes.root}>
          <AppBar position="static" className={classes.appBar} color="default">
            <Toolbar className={classNames('maxWidth', classes.toolbar)}>
              <Hidden mdUp>
                <IconButton color="inherit" aria-label="Menu" onClick={this.handleDrawerOpen.bind(this)}>
                  <Icon>menu</Icon>
                </IconButton>
              </Hidden>
              <Hidden mdUp>
                <div className={classes.grow} />
              </Hidden>
              <a href="/" onClick={this.handleClickHome}><img src="/demobank-logo.png" className={classes.logo} alt="Demobank logo" /></a>
              <Hidden smDown>
                <ul className={classes.appBarMenu}>
                  {this.menuItems.map((v, k) => (
                    <li key={k}>
                      <a href={"/" + v.toLowerCase()} onClick={(e) => e.preventDefault()}>
                        {v}
                      </a>
                    </li>
                  ))
                  }
                </ul>
              </Hidden>
              <div className={classes.grow} />
              <Tooltip title="Force workflow">
                <IconButton color="inherit" onClick={this.handleForceWorkflowMenu(true)}>
                  <Badge variant="dot" invisible={!Boolean(api.forceWorkflow)} color="secondary">
                    <FontAwesomeIcon icon={faProjectDiagram} color="#999" />
                  </Badge>
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={menuForceWorkflow}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                getContentAnchorEl={null}
                open={Boolean(menuForceWorkflow)}
                onClose={this.handleForceWorkflowMenu(false)}
                MenuListProps={{
                  subheader:
                    <ListSubheader component="div" className={classes.forceWorkflowSubheader}>
                      Force Workflow
                  </ListSubheader>
                }}
              >
                {
                  forceWorkflows.map((w, i) =>
                    <MenuItem key={i} dense={true} divider={w.divider} selected={api.forceWorkflow === w.value} onClick={this.handleForceWorkflow(api.forceWorkflow === w.value ? null : w.value)}>
                      <ListItemIcon>
                        <Badge variant="dot" invisible={api.forceWorkflow !== w.value} color="secondary" style={{ padding: 0 }}>
                          <FontAwesomeIcon icon={w.icon} fixedWidth />
                        </Badge>
                      </ListItemIcon>
                      {w.text}
                    </MenuItem>
                  )
                }
              </Menu>
              {(config.aa.mode === "proxy" || config.aa.mode === "direct") &&
                <Tooltip title="View trace log">
                  <Badge badgeContent={tracelog.unread} overlap="circle" color="secondary">
                    <IconButton color="inherit" onClick={() => this.handleSoapViewerOpen(true)}>
                      <FontAwesomeIcon icon={faEnvelopeOpenText} color="#999" />
                    </IconButton>
                  </Badge>
                </Tooltip>
              }
            </Toolbar>
          </AppBar>
          <Hidden mdUp>
            <ClickAwayListener onClickAway={this.handleDrawerClose.bind(this)}>
              <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={menuOpen}
                classes={{
                  paper: classes.drawerPaper,
                }}
              >
                <div className={classes.drawerHeader}>
                  <IconButton onClick={this.handleDrawerClose.bind(this)}>
                    <FontAwesomeIcon icon={theme.direction === 'ltr' ? faChevronLeft : faChevronRight} />
                  </IconButton>
                </div>
                <Divider />
                {auth.authenticated &&
                  <Fragment>
                    <PibMenu itemClick={this.handleDrawerClose.bind(this)} />
                    <Divider />
                  </Fragment>
                }
                {menuItems.map((i, k) =>
                  <ListItem key={k} button>
                    <ListItemIcon className={classes.listItemIcon}>
                      <FontAwesomeIcon icon={i.icon} fixedWidth />
                    </ListItemIcon>
                    <ListItemText primary={i.text} />
                  </ListItem>)}
              </Drawer>
            </ClickAwayListener>
          </Hidden>
          <div className={classes.main}>
            <Switch>
              <Route exact path={`${match.path}/`} component={Login} />
              <Route path={`${match.path}/pib`} component={PIBContainer} />
              <Route path={`${match.path}/bind`} component={BindContainer} />
              <Route path={`${match.path}/enroll`} component={EnrollContainer} />
              <Route component={ErrorPage} />
            </Switch>
            <Copyright className={classes.copyright} />
          </div>
        </div>
        <SoapViewer />
      </Fragment>
    )
  }
}

const mapStateToProps = ({ api, challenge, auth, config, tracelog }: IStoreState) => ({
  api,
  auth,
  challenge,
  config,
  tracelog
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      setRequestArgs,
      setForceWorkflow,
      initApi,
      logout,
      push,
      setProxy,
      handleNewBroadcast,
      setViewerVisibility,
      proxyBase,
      setAAMode
    }, dispatch
  )

interface MatchParams {
  proxyId: string
}

interface Props extends WithTheme, WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, RouteComponentProps<MatchParams> {
  mode: AAMode
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(MainApp));
